<template>
  <div class="payment-method">
    <app-loading :loading="loading">
      <template v-if="data.provider">
        <div class="title">
          {{ $ml.get(`Payment method`) }}
        </div>
        <template v-if="data.provider === 'stripe'">
          <template v-if="data.pm">
            <div class="info">
              <div class="card">
                <span class="brand">{{ data.pm.card.brand }}</span>
                {{ $ml.get(`ending on`) }}
                <b>{{ data.pm.card.last4 }}</b>
              </div>
              <div class="exp">
                {{ $ml.get(`Expire:`) }} <b>{{ data.pm.card.exp_month }}/{{ data.pm.card.exp_year }}</b>
              </div>
            </div>
            <button @click="opened_pm_modal = true" class="update h-empty-btn">
              {{ $ml.get('Update') }}
            </button>
          </template>
          <template v-else>
            <div class="no-pm">
              You don't have <br> payment method
            </div>
            <button @click="opened_pm_modal = true" class="update h-empty-btn">
              {{ $ml.get('Add payment method') }}
            </button>
          </template>
        </template>
        <template v-else-if="data.provider === 'apple-iap'">
          <div class="apple">
            <div class="text">
              <div class="logo">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="35.676px" height="35.676px" viewBox="0 0 35.676 35.676" style="enable-background:new 0 0 35.676 35.676;" xml:space="preserve">
                  <g>
                    <path d="M32.295,26.202c-0.096,0.271-0.189,0.562-0.296,0.848c-0.886,2.399-2.231,4.529-3.863,6.481 c-0.315,0.38-0.682,0.724-1.061,1.043c-0.749,0.634-1.611,1.017-2.608,1.052c-0.749,0.024-1.468-0.112-2.161-0.394 c-0.502-0.205-0.996-0.434-1.505-0.619c-1.652-0.6-3.295-0.521-4.92,0.121c-0.586,0.232-1.164,0.488-1.761,0.689 c-0.692,0.232-1.41,0.326-2.141,0.188c-0.638-0.119-1.196-0.416-1.714-0.799c-0.643-0.476-1.183-1.056-1.688-1.67 c-2.391-2.916-3.996-6.213-4.771-9.906c-0.334-1.588-0.494-3.189-0.396-4.812c0.115-1.946,0.567-3.799,1.607-5.469 c1.305-2.099,3.146-3.474,5.568-4.041c1.457-0.343,2.874-0.203,4.263,0.332c0.731,0.28,1.464,0.557,2.198,0.832 c0.676,0.254,1.349,0.254,2.026-0.005c0.749-0.286,1.499-0.571,2.251-0.85c0.771-0.281,1.555-0.511,2.373-0.576 c1.224-0.099,2.418,0.06,3.58,0.449c1.647,0.551,2.987,1.526,3.999,2.946c0.027,0.039,0.057,0.082,0.077,0.113 c-2.552,1.779-4.005,4.129-3.794,7.311C27.771,22.65,29.485,24.804,32.295,26.202z M17.98,8.253 c0.753,0.02,1.477-0.125,2.174-0.402c3.179-1.262,4.841-4.625,4.791-7.197C24.941,0.447,24.927,0.24,24.918,0 c-0.327,0.049-0.625,0.072-0.911,0.144c-2.321,0.569-4.107,1.864-5.281,3.961c-0.687,1.228-1.069,2.532-0.952,3.957 C17.782,8.213,17.837,8.251,17.98,8.253z"/>
                  </g>
                </svg>
              </div>
              {{ $ml.get(`Your payment method is linked to your`) }} <b>apple</b> {{ $ml.get(`device`) }}
            </div>
          </div>
        </template>
      </template>
    </app-loading>

    <transition name="modal-fade-scale">
      <UpdatePaymentMethodModal
        v-if="opened_pm_modal"
        @close="opened_pm_modal = false"
        @update="sync"
      />
    </transition>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { UserAPI } from '@/api';
import UpdatePaymentMethodModal from './UpdatePaymentMethodModal';
export default {
  data() {
    return {
      data: {},
      loading: false,
      opened_pm_modal: false,
    }
  },
  computed: {

    ...mapGetters({
      user: 'user/data',
    }),
  },
  methods: {

    sync() {
      this.loading = true;
      UserAPI.getPaymentMethod().then(res => {
        this.data = res.data;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  components: {
    UpdatePaymentMethodModal,
  },
  mounted() {
    this.sync();
  }
}
</script>

<style lang="scss" scoped>

.payment-method {

  border-radius: 5px;
  background: #f7f7f7;
  margin-right: 20px;
  border-bottom: 5px solid #eee;
  max-width: 250px;
  padding: 10px;
  line-height: 1.5;
  flex-grow: 1;

  &:last-child {
    margin-right: 0;
  }

  .app-loading {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .title {
    margin-bottom: 10px;
  }

  .info {
    flex-grow: 1;

    .brand {
      border: 1px solid #333;
      padding: 0 4px;
      border-radius: 2px;
      font-weight: bold;
      text-transform: uppercase;
      font-size: 13px;
    }
  }

  .no-pm {
    flex-grow: 1;
    line-height: 1.2;
  }

  .update {
    font-size: 12px;
    color: $mainGreen;
    margin-top: 5px;
  }

  .apple {
    .logo {
      display: inline-flex;
      align-items: center;
      justify-content: center;

      width: 26px;
      height: 26px;
      border: 1px solid #333;
      border-radius: 4px;
      vertical-align: middle;
      svg {
        width: 16px;
        height: auto;
      }
    }
  }
}

</style>
